import React from "react";
import Styles from "./Loading.module.scss";

const Loading = props => {
  return props.error && props.message ? (
    <>
      <div className={Styles.header}>
        <h1 className={Styles.title}>{props.error}</h1>
        <p className={Styles.intro}>{props.message}</p>
      </div>
    </>
  ) : (
    <div className={Styles.ldsEllipsis}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default Loading;
